import type { FaireProductEntity } from "../../entity_types/product";

export const p_cp6g3htvdz: FaireProductEntity = {
  token: "p_cp6g3htvdz",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - LIGHT CAMO",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/bf286425665a5c167fe19fea5ac4249e63f90b5b44f9039fde18a04bfb3558d1.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:29.684Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
